import { useAuth } from "@risalabs_frontend_org/auth-wrapper";
import { useNavigate } from "react-router-dom";
import ClaimsIcon from "../../../shared/svg/claims";
import ClaimsIconFilled from "../../../shared/svg/claimsIconFilled";
import ConfigFilledIcon from "../../../shared/svg/configFilledIcon";
import ConfigIcon from "../../../shared/svg/configIcon";
import Exit from "../../../shared/svg/exit";
import HumanIcon from "../../../shared/svg/humanIcon";
import MedicalCard from "../../../shared/svg/medicalCardIcon";
import RisaLogoWhite from "../../../shared/svg/risa-logo-white";
import SingleTabWithLink, {
  SingleTabWithLinkProps,
} from "../../components/singleTabWithLink/singleTabWithLink";
import {
  canAccessCommonSection,
  canAccessSection,
  isDevBypassEnabled,
} from "../../utils/configAccess";

interface SectionTab extends SingleTabWithLinkProps {
  visible: boolean;
}

const buildSectionTabs = (): SectionTab[] => [
  {
    id: "configurations/med_onc",
    label: "Medonc",
    defaultIcon: <HumanIcon fill="#999999" width={20} height={20} />,
    selectedIcon: <HumanIcon fill="#FFFFFF" width={20} height={20} />,
    visible: canAccessSection("med_onc"),
  },
  {
    id: "configurations/pharmacy",
    label: "Pharma",
    defaultIcon: <MedicalCard width="20" height="20" fillColor="#999999" />,
    selectedIcon: <MedicalCard width="20" height="20" fillColor="#FFFFFF" />,
    visible: canAccessSection("pharmacy"),
  },
  {
    id: "configurations/claims",
    label: "Claims",
    defaultIcon: <ClaimsIcon />,
    selectedIcon: <ClaimsIconFilled />,
    visible: canAccessSection("claims"),
  },
  {
    id: "configurations/common",
    label: "Common",
    defaultIcon: <ConfigIcon />,
    selectedIcon: <ConfigFilledIcon />,
    visible: canAccessCommonSection(),
  },
];

const Header = () => {
  const tabs = buildSectionTabs().filter((tab) => tab.visible);
  return (
    <div className="flex h-full flex-col gap-6">
      <div className="header--logo">
        <RisaLogoWhite height="52" width="52" />
      </div>
      <div className="header--tabs flex flex-1 flex-col gap-5">
        {tabs.map((tab) => (
          <SingleTabWithLink
            key={tab.id}
            id={tab.id}
            label={tab.label}
            defaultIcon={tab.defaultIcon}
            selectedIcon={tab.selectedIcon}
          />
        ))}
      </div>
      {isDevBypassEnabled() ? null : <HeaderUserActions />}
    </div>
  );
};

const HeaderUserActions = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  return (
    <div className="header--actions mb-6 flex flex-col items-center justify-center gap-6">
      <div
        className="flex h-8 w-8 items-center justify-center overflow-hidden rounded-full bg-gray-200 hover:scale-105 hover:cursor-pointer"
        onClick={() => navigate("/settings")}
      >
        <img
          src={user?.profilePicUrl || "/user.png"}
          alt="profile-pic"
          className="h-full w-full object-cover"
        />
      </div>
      <div className="hover:scale-105 hover:cursor-pointer">
        <Exit onClick={() => logout()} stroke="white" />
      </div>
    </div>
  );
};

export default Header;
